import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Button, Paper, Typography, Box } from "@mui/material";
import { coloreDisponibile, coloreOccupato } from "../../const/general/colorApp";
import { convalidaOtpRichiestaCredenzialiButtonText } from "../../const/DialogData";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showLoader } from "../../redux/reducers/appLoader-reducer";
import { useTranslation } from "react-i18next";

const grandezzaLogo = "120px";

export default function ConvalidaResetPasswordResponse({ outCome = false }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (outCome === null) {
      dispatch(showLoader());
    }
  }, [outCome, dispatch]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "90%",
          maxWidth: "500px",
          minHeight: "450px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 4,
          borderRadius: 3,
        }}
      >
        {outCome !== null && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* ICONA */}
            <Box>
              {outCome ? (
                <CheckCircleIcon
                  sx={{ fontSize: grandezzaLogo, color: coloreDisponibile }}
                />
              ) : (
                <CancelIcon
                  sx={{ fontSize: grandezzaLogo, color: coloreOccupato }}
                />
              )}
            </Box>

            {/* TESTO */}
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
                {outCome ? t("confirmed_title") : t("error_title")}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {outCome
                  ? t("reset_password_confirmed")
                  : t("reset_password_error")}
              </Typography>
            </Box>

            {/* BOTTONE */}
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/")}
              sx={{ minWidth: "200px" }}
            >
              {t(convalidaOtpRichiestaCredenzialiButtonText.Indietro)}
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
}